import {
  getBillBrandTableColumn,
  getAccountTableColumn,
  getRegionTableColumn,
  getTagTableColumn,
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  created () {
    this.columns = [
      {
        field: 'name',
        title: this.$t('bill.text_127'),
        sortable: true,
        slots: {
          default: ({ row }) => {
            return [
              <div class='text-truncate'>
                <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
                <list-body-cell-wrap copy row={row} field='id' hideField title={row.id}><span style="color: #999;">{row.id}</span></list-body-cell-wrap>
              </div>,
            ]
          },
        },
        formatter: ({ row }) => {
          return row.name
        },
      },
      getCopyWithContentTableColumn({
        field: 'external_id',
        title: this.$t('bill.resource_tag.external_id'),
      }),
      {
        field: 'resource_type',
        title: this.$t('bill.resource_tag.resource_type'),
        minWidth: 50,
        formatter: ({ row }) => {
          return getBillResourceTypeLabel(row.resource_type)
        },
      },
      {
        field: 'origin_res_type',
        title: this.$t('bill.resource_tag.origin_resource_type'),
        minWidth: 50,
        slots: {
          default: ({ row }, h) => {
            return row.origin_res_type || '-'
          },
        },
      },
      getTagTableColumn({
        title: this.$t('dictionary.instance_tag'),
        width: 100,
        manager: new this.$Manager('meter_instances', 'v2'),
        onManager: this.onManager,
        resource: 'meter_instances',
        params: { resources: 'meter_instance' },
        vm: this,
        columns: () => this.columns,
        editCheck: () => this.$store.getters.isAdminMode,
      }),
      getBillBrandTableColumn(),
      getAccountTableColumn({ managerField: 'spec.manager' }),
      {
        field: 'project',
        title: this.$t('dictionary.project'),
        sortable: true,
        slots: {
          default: ({ row }) => {
            const projectSrc = row.project_src === 'local' ? <span>({this.$t('bill.bill_task.task_mode.manual')})</span> : null

            return [
              <div class='text-truncate'>
                <list-body-cell-wrap copy row={row} field='domain' title={row.domain} />
                <list-body-cell-wrap copy row={row} field='project' hideField title={row.project}>
                  <span style="color: #999;">{row.project}{projectSrc}</span>
                </list-body-cell-wrap>
              </div>,
            ]
          },
        },
        formatter: ({ row }) => {
          return row.project
        },
      },
      {
        field: 'instance_src',
        title: this.$t('bill.resource_tag.instance_src'),
        slots: {
          default: ({ row }) => {
            return [
              <span>{row.instance_src === 'bill' ? this.$t('bill.resource_tag.instance_src.bill') : this.$t('bill.resource_tag.instance_src.cloud')}</span>,
            ]
          },
        },
      },
      getRegionTableColumn(),
      getTimeTableColumn(),
    ]
  },
}
